export const enum TestIds {
  AssessmentFrequency = 'riskForm-assessmentFrequency',
  Contributors = 'riskForm-contributors',
  Departments = 'riskForm-departments',
  Description = 'riskForm-description',
  Entity = 'riskForm-entity',
  Name = 'riskForm-name',
  NextTestDate = 'riskForm-nextTestDate',
  Owners = 'riskForm-owners',
  ParentRiskId = 'riskForm-parentRiskId',
  Status = 'riskForm-status',
  Tags = 'riskForm-tags',
  Tier = 'riskForm-tier',
  Treatment = 'riskForm-treatment',
  Viewers = 'riskForm-viewers',
}
